import React, { useState } from "react";
import { Drawer, List, ListItem, ListItemIcon, ListItemButton, Tooltip } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import EvStationIcon from "@mui/icons-material/EvStation";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import LogoutIcon from "@mui/icons-material/Logout";
import Logo from "./Logo";
import { useDispatch, useSelector } from "react-redux";
import { clearLoginState } from "../slice/LoginSlice";
import MapIcon from '@mui/icons-material/Map';
import GridViewIcon from '@mui/icons-material/GridView';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import WalletIcon from '@mui/icons-material/Wallet';
import { applyFleetOrNonFleetFilter } from "../slice/StationListSlice";

const drawerWidth = 70;

const Sidebar = () => {
  const location = useLocation();
  const [_activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const { selectedFacility } = useSelector(state => state.stationList);

  const userData = useSelector((state) => state.user.data.data);
  const countryData = useSelector((state) => state.country.data.data);

  const menuItems = [
    { icon: <AutoAwesomeMosaicIcon />, name: "Dashboard", link: "/dashboard" },
    { icon: <BookOnlineIcon />, name: "Overview", link: "/station" },
    { icon: <EvStationIcon />, name: "Station Management", link: "/charging-stations" },
    // { icon: <PersonIcon />, name: "User Management", link: "/user-management" },
    { icon: <AccountBalanceWalletIcon />, name: "Billing And Payment", link: "/billing-payment" },
    { icon: <MapIcon />, name: "Map", link: "/map" },
    // { icon: <QuestionAnswerIcon />, name: "QuestionAnswer", link: "/dashboard" },
    // { icon: <GridViewIcon />, name: "My App", link: "/my-app" },
  ];

  if (userData?.facility_admin_type === "superadmin" || userData?.facility_admin_type === "countryadmin") {
    menuItems.splice(3, 0, { icon: <PersonIcon />, name: "User Management", link: "/user-management" });
    menuItems.push({ icon: <CardGiftcardIcon />, name: "Coupon", link: "/coupon" })
    menuItems.push({ icon: <AccountBalanceIcon />, name: "OCPI", link: "/ocpi" })
    if (countryData?.find(item => userData?.country === item?.name)?.is_refund_enabled)
      menuItems.push({ icon: <WalletIcon />, name: "Payments And Transactions", link: "/payments-and-transactions" })
  }

  const handleItemClick = (index, event) => {
    setActiveIndex(index);
    if(selectedFacility?.name === "All")
    dispatch(applyFleetOrNonFleetFilter(selectedFacility?.all))
  };

  const handleLogout = () => {
    navigate('/login');
    localStorage.clear();
    dispatch(clearLoginState());
  };

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          overflowX: "hidden",
          margin: '0px 0px 0px 0px',
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Logo />
      <List>
        {menuItems.map((menuItem, index) => (
          <Tooltip title={menuItem.name} key={index} arrow placement="right">
            <ListItem
              sx={{
                padding: 2,
                backgroundColor:
                  location.pathname === menuItem.link ? "#e0e0e0" : "transparent",
                justifyContent: "center"
              }}
              onClick={(event) => handleItemClick(index, event)}
              component={Link}
              to={menuItem.link}
            >
              <ListItemIcon style={{ minWidth: "auto" }}>{menuItem.icon}</ListItemIcon>
            </ListItem>
          </Tooltip>
        ))}
      </List>
      <List style={{ position: "absolute", bottom: "0px", width: "100%" }}>
        {["LogoutIcon"].map((iconKey, index) => (
          <Tooltip title="Logout" key={index} arrow placement="right">
            <ListItem
              key={iconKey}
              disablePadding
              component={Link}
              // to="/login"
              onClick={handleLogout}
              sx={{
                justifyContent: "center",
                width: "100%"
              }}
            >
              <ListItemButton style={{ justifyContent: "center" }}>
                <ListItemIcon style={{ minWidth: "auto" }}>{<LogoutIcon />}</ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
